import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../service/AuthService";

const PrivateRoutes = () => {
    return (
        getToken() ? <Outlet /> : <Navigate to='/Login' />
    )
}

export default PrivateRoutes;